// create bar graph that takes values from accesslog and returns them in a pretty form
// input
import * as React from "react";
import * as d3 from "d3";
import { useEffect, useState } from "react";

interface BarGraphStackedProps {
  [x: string]: any;
  data: Array<{
    date: Date;
    level: string;
    val: number;
    // PG: number;
    // UG: number;
    // Other: number;
    // Total: number;
  }>;
}

function BarGraphStacked(props: BarGraphStackedProps) {
  //function BarGraphStacked(props) {
  // to enable multiple images on same page
  function generateUUID() {
    return "BarSG_xxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  const [container, setContainer] = useState(generateUUID());
  // console.log("insideBG:", props.data)
  useEffect(() => {
    if (props.data.length > 0) {
      drawChart();
      //console.log('is this being called???')
    } else {
      d3.select("#" + container)
        .selectChildren()
        .remove();
      //console.log('is this being called')
      //console.log(props.data)
    }
  }, [props]);

  const drawChart = () => {
    // Declare the chart dimensions and margins.
    const width = props.width;
    const height = 500;
    const marginTop = 20;
    const marginRight = 30;
    const marginBottom = 30;
    const marginLeft = 40;

    let _index: any = d3.index(
      props.data,
      (d) => d.date.toDateString(),
      (d) => d.level,
    );
    const series = d3
      .stack()
      .keys(d3.union(props.data.map((d) => d.level)))
      .value(([, group]: any, key) => group.get(key).val)(_index);

    // console.log("series:",series);

    // Declare the x (horizontal position) scale.
    const xScale = d3
      .scaleBand()
      .range([marginLeft, width - marginRight])
      .domain(
        props.data.map(
          (d) =>
            (d.date.getMonth() + 1).toString() +
            " " +
            "/" +
            " " +
            d.date.getUTCFullYear().toString(),
        ),
      )
      .padding(0.1);

    // Declare the y (vertical position) scale.
    const yScale = d3
      .scaleLinear()
      // .domain([0, d3.max(props.data, (d) => d.val)])
      .domain([0, d3.max(series[2], (d) => d[1])])
      .range([height - marginBottom, marginTop]);

    const colours = d3
      .scaleOrdinal<string>()
      .domain(["PG", "UG", "Other"])
      .range(["#622567", "#d55c19", "#007a87"]);

    d3.select("#" + container)
      .selectChildren()
      .remove();
    // Create the SVG container.

    const svg = d3
      .select("#" + container)
      .append("svg")
      .attr("width", width)
      .attr("height", height + 100)
      .attr("viewBox", [0, 0, width, height + 80]);

    svg
      .append("g")
      .selectAll("g")
      .data(series)
      .join("g")
      .attr("fill", (d) => colours(d.key))
      .selectAll("rect")
      .data((D) => D)
      .join("rect")
      .attr("x", (d) => {
        let format = d3.timeFormat("%-m / %Y");
        //console.log("d:",   format(new Date(Date.parse(d.data[0].toString()))))
        return xScale(format(new Date(Date.parse(d.data[0].toString()))));
      })
      .attr("y", (d) => yScale(d[1]))
      .attr("height", (d) => yScale(d[0]) - yScale(d[1]))
      .attr("width", xScale.bandwidth());

    // Add the x-axis and label.
    svg
      .append("g")
      .attr("transform", `translate(0,${height})`)
      .call(
        d3
          .axisBottom(xScale)
          .ticks(props.data.length, d3.utcFormat("%B %Y"))
          .tickSizeInner(10)
          .tickSizeOuter(5)
          .tickFormat(null),
      )
      .selectAll("text")
      .style("text-anchor", "end")
      .attr("dx", "-1.35em")
      .attr("dy", "-0.6em")
      .attr("transform", "rotate(-80)");
    // Add the y-axis and label, and remove the domain line.
    svg
      .append("g")
      .attr("transform", `translate(${marginLeft},0)`)
      .call(d3.axisLeft(yScale).tickFormat(null))
      .call((g) => g.select(".domain").remove())
      .call((g) =>
        g
          .append("text")
          .attr("x", -marginLeft)
          .attr("y", 10)
          .attr("fill", "currentColor")
          .attr("text-anchor", "start")
          .text("↑ Times AOS Accessed"),
      );
  };
  return <div className={"BarGraph"} id={container} />;
}
export default BarGraphStacked;
